/* eslint-disable react-hooks/exhaustive-deps */
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { umamiTracking } from "helpers/utils"
import { dataEditorDefault } from "pages/project-component-detail/types"
import { useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { STATUS_RESPONSE } from "types"
import {
  ConversationMessagesDetailItem,
  ConversationMessagesDetail,
} from "../conversations.type"
import MessagesConversationItemCard from "../molecules/MessagesConversationItemCard"
import { postConversationSendMessageMiddleware } from "../conversations.api"
import { useAppSelector } from "hooks/useApp"
import { useBoolean, useWindowSize } from "helpers/hooks"
import FormInputEditorCard from "pages/project-build/molecules/FormInputEditorCard"
import { useAdditionalAndExtraInfoProjectBuild } from "pages/project-build/project-build.hook"
import ModalDelete from "components/ModalCustom/ModalDelete"
import { ReactComponent as IconMessagerDeleteComponent } from "assets/images/icons/icon-messager-delete-component.svg"
import { v4 as uuid } from "uuid"
import { isEmpty, isUndefined } from "lodash"
import { configureStore } from "stores/configureStore"
import { closeLoading, startLoading } from "reducers/loading"
import { useUploadFileWorkerController } from "workers/uploadFileWorkerController"
import {
  getProjectBuildInviteeMiddleware,
  postProjectBuildSendInviteeMiddleware,
} from "pages/project-build/api.services"
import { useAddComponentInInvitee } from "hooks/useAddComponentInInvitee"
import { EVENT } from "constants/events"
import { FormBackup } from "components/FormBackup/FormBackup"
import Button from "components/Button/Button"

interface Props {
  originMessages: ConversationMessagesDetailItem[]
  idConversation: string
  isEditorInput: boolean
  inviteeUser: ConversationMessagesDetail["invitee"]
  isChangeScrollMessageBottom: {
    value: boolean
    setValue: (value: boolean) => void
  }
  updateWhenAddMessager: (message: string) => void
  onScrollMessage: () => void
  isDeleted?: boolean
  notYetCommented: boolean
  disableButtonEditor?: boolean
  projectId: string
  isLoadingMessage: boolean
  isRenderScroll: {
    value: boolean
    setValue: (value: boolean) => void
  }
  subNameDownload: string
  collapseComponent: boolean
  organizationActive: {
    value: string
    setValue: (value: string) => void
  }
}
const TabCoversationDetail = (props: Props) => {
  const {
    originMessages,
    isEditorInput,
    idConversation,
    inviteeUser,
    isChangeScrollMessageBottom,
    onScrollMessage,
    updateWhenAddMessager,
    isDeleted,
    notYetCommented,
    disableButtonEditor,
    projectId,
    isLoadingMessage,
    isRenderScroll,
    subNameDownload,
    collapseComponent,
    organizationActive,
  } = props
  const { isMobile } = useWindowSize()
  const userInfo = useAppSelector((state) => state.userInfo)
  const openWarningModal = useBoolean(false)
  const scrollHeightWhenLoadMoreMessage = useRef(0)
  const [scrollDirection, setScrollDirection] = useState<"top" | "bottom">(
    "bottom"
  )
  const showIconScroll = useBoolean(false)
  const {
    dataEditor,
    isLoading,
    keyInputFile,
    ref,
    listFileAdd,
    setDataEditor,
    fileSelectedHandler,
    handleChangeEditor,
    handleDeleteFileNoDownload,
    setListFileAdd,
    handleChangeScroll,
    clearStorageWhenSubmit,
  } = useAdditionalAndExtraInfoProjectBuild(
    "tab_conversation_detail",
    idConversation
  )

  const {
    syncNewVersionComponentInvitee,
    isLoadingBackupInvitee,
    messageBackups,
    currentMessageBackup,
    errorMessageBackup,
  } = useAddComponentInInvitee()

  const { workerUploadFile } = useUploadFileWorkerController()

  useEffect(() => {
    if (!isChangeScrollMessageBottom.value) {
      return
    }
    setTimeout(() => {
      handleChangeScroll()
      isChangeScrollMessageBottom.setValue(false)
    }, 2000)
  }, [isChangeScrollMessageBottom.value])

  useEffect(() => {
    if (!isRenderScroll.value) {
      return
    }
    if (ref.current) {
      const el = ref.current
      const newScrollTop =
        el.scrollHeight - scrollHeightWhenLoadMoreMessage.current
      el.scrollTop = newScrollTop
      isRenderScroll.setValue(false)
    }
  }, [isRenderScroll.value])

  const handleScroll = () => {
    if (!ref.current) return
    const { scrollTop, scrollHeight, clientHeight } = ref.current
    const lengthScroll = isMobile ? 100 : 300
    if (scrollHeight - clientHeight > lengthScroll) {
      showIconScroll.setValue(true)
    } else {
      showIconScroll.setValue(false)
    }
    if (scrollTop === 0) {
      setScrollDirection("bottom")
    } else if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setScrollDirection("top")
    }
  }
  useEffect(() => {
    if (collapseComponent) {
      setTimeout(() => {
        handleScroll()
      }, 500)
    }
  }, [collapseComponent])

  useEffect(() => {
    const el = ref.current
    if (el) el.addEventListener("scroll", handleScroll)
    return () => {
      if (el) el.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const onWarningSubmit = (dataEditor: string) => {
    if (!inviteeUser.email || inviteeUser.is_sent) {
      onSubmitButton(dataEditor)
      return
    }
    openWarningModal.setValue(true)
    setDataEditor(dataEditor)
  }

  const onSubmitButton = async (dataEditor: string) => {
    if (!idConversation || !workerUploadFile) {
      toast(
        <LabelNotificationPage
          messenger="The workerUploadFile is not working!"
          type="error"
        />
      )
      return
    }

    if (!inviteeUser.is_sent && openWarningModal.value) {
      const dataInvitees = await getProjectBuildInviteeMiddleware(
        inviteeUser.project_build_id
      )
      const inviteeByConversation = dataInvitees.find(
        (el) => el.conversation_id === idConversation
      )
      if (inviteeByConversation) {
        const emailSend = inviteeByConversation.publicKeyCCs?.length
          ? inviteeByConversation.publicKeyCCs
              .filter((item) => !item.is_sent)
              .map((item) => item.email)
          : []
        if (!inviteeByConversation.is_sent_invitee) {
          emailSend.push(inviteeByConversation.email)
        }
        if (emailSend.length) {
          umamiTracking(EVENT.INVITEE.SEND_INVITATION)
          const generateDataKeyPairUsers = await syncNewVersionComponentInvitee(
            inviteeByConversation.project_build_components,
            projectId,
            inviteeByConversation,
            inviteeUser.project_build_id,
            inviteeByConversation.conversation_id,
            emailSend
          )
          configureStore.dispatch(startLoading())
          setTimeout(() => {
            postProjectBuildSendInviteeMiddleware(
              inviteeByConversation.id,
              "Send",
              (type: STATUS_RESPONSE, _messenger: string) => {
                if (type === STATUS_RESPONSE.SUCCESS) {
                  sendConversationMessage(dataEditor)
                }
              },
              emailSend,
              generateDataKeyPairUsers
            )
          }, 500)
        }
      }
      openWarningModal.setValue(false)
      return
    }
    sendConversationMessage(dataEditor)
  }

  const sendConversationMessage = async (dataEditor: string) => {
    if (!idConversation || !workerUploadFile) {
      toast(
        <LabelNotificationPage
          messenger="The workerUploadFile is not working!"
          type="error"
        />
      )
      return
    }
    isLoading.setValue(true)
    let newDataEditor = dataEditor
    listFileAdd
      .filter((item) => item.type === "inline")
      .forEach((item) => {
        newDataEditor = newDataEditor.replace(item.url || "", item.id)
      })

    configureStore.dispatch(startLoading())

    postConversationSendMessageMiddleware(
      workerUploadFile,
      idConversation,
      organizationActive.value,
      {
        content: isEmpty(newDataEditor) ? dataEditorDefault : newDataEditor,
        files: listFileAdd.map((file) => {
          return {
            file: file.file,
            file_name: file.name,
            key: file.id ?? uuid(),
            type: file.type,
            file_type: file.file_type,
          }
        }),
      },
      (type: STATUS_RESPONSE, messenger: string) => {
        isLoading.setValue(false)
        if (type === STATUS_RESPONSE.SUCCESS) {
          setListFileAdd([])
          setDataEditor("")
          clearStorageWhenSubmit()
          updateWhenAddMessager(dataEditor)
        } else {
          closeLoading()
          toast(<LabelNotificationPage messenger={messenger} type={type} />)
        }
      }
    )
  }

  const onDisableButtonSubmit = () => {
    let value = true
    if (dataEditor !== dataEditorDefault || listFileAdd.length) {
      value = false
    }
    if (!isUndefined(disableButtonEditor) && disableButtonEditor) {
      return true
    }
    return value
  }

  const onchangeEditor = async (value: string) => {
    await handleChangeEditor(value)
  }
  const handleClickScroll = () => {
    if (!ref.current) return

    if (scrollDirection === "bottom") {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: "smooth",
      })
    } else {
      ref.current.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  const renderButtonScroll = () => {
    return (
      <button
        className="scroll-btn"
        onClick={handleClickScroll}
        style={{
          top: inviteeUser?.id && !Boolean(inviteeUser.is_sent) ? 70 : 20,
        }}
      >
        {scrollDirection === "top" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18.0702 9.57L12.0002 3.5L5.93018 9.57"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 20.4999V3.66992"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18.0702 14.4302L12.0002 20.5002L5.93018 14.4302"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 3.5V20.33"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        )}
      </button>
    )
  }

  return (
    <div className="flex flex-col justify-between h-full relative">
      <div className="flex-1 overflow-auto" ref={ref}>
        <div className="pr-0 md:pr-[24px]">
          {isLoadingMessage ? (
            <div className="flex justify-center mb-[12px]">
              <Button
                title="Load more"
                colorBtn="white"
                onClick={() => {
                  const scrollHeight = ref.current?.scrollHeight
                  scrollHeightWhenLoadMoreMessage.current = Number(scrollHeight)
                  onScrollMessage()
                }}
                styleButton={{
                  marginLeft: 8,
                }}
                sizeBtn="small"
              />
            </div>
          ) : null}

          {originMessages.length
            ? originMessages.map((messages, index) => (
                <MessagesConversationItemCard
                  idUserInfo={userInfo.id}
                  idInviteeUser={inviteeUser.user_id}
                  messages={messages}
                  key={index}
                  styleRoot={{
                    marginBottom: index === originMessages.length - 1 ? 0 : 12,
                  }}
                  isActiveConversation={isEditorInput && !isDeleted}
                  conversationId={idConversation}
                  subNameDownload={subNameDownload}
                  dbKey={organizationActive.value}
                />
              ))
            : null}
        </div>
      </div>
      {!isDeleted && isEditorInput ? (
        <div className="flex flex-col conversation-editor relative">
          {inviteeUser?.id && !Boolean(inviteeUser.is_sent) ? (
            <div className="pr-0 md:pr-6 mt-3">
              <div
                className="flex items-center px-2 mb-3 last:mb-0"
                style={{
                  minHeight: 38,
                  background: "rgba(232, 122, 22, 0.20)",
                  borderRadius: 6,
                }}
              >
                <IconMessagerDeleteComponent className="icon-warning-messager" />
                <p
                  className="font-normal text-13 leading-22  pl-1"
                  style={{
                    color: "#E87A16",
                  }}
                >
                  Warning: Invitation was not sent.
                </p>
              </div>
            </div>
          ) : null}
          <FormInputEditorCard
            handleChangeEditor={onchangeEditor}
            dataEditor={dataEditor}
            fileSelectedHandler={fileSelectedHandler}
            listFileAdd={listFileAdd}
            keyInputFile={keyInputFile.value}
            handleDeleteFileNoDownload={handleDeleteFileNoDownload}
            onSubmitButton={onWarningSubmit}
            onDisableButtonSubmit={onDisableButtonSubmit()}
            id={idConversation}
            styleRoot={{
              height: "auto",
              position: "relative",
            }}
          />
          {showIconScroll.value ? renderButtonScroll() : null}
        </div>
      ) : null}
      {openWarningModal.value && (
        <ModalDelete
          onCloseModal={() => openWarningModal.setValue(false)}
          title={`You are about to send a message and invitation to the invitee, which will appear in their email inbox. Please ensure the invitee's email is accurate.`}
          content="This pop-up window will not reappear once you press Proceed."
          label={`Warning`}
          onSubmit={() => onSubmitButton(dataEditor)}
          titleButton="Proceed"
          styleTitle={{
            textAlign: "center",
            // width: 360,
            marginBottom: 10,
          }}
          contentWrapperStyles={{
            paddingTop: 10,
            paddingBottom: 36,
            textAlign: "center",
          }}
        />
      )}
      {isLoadingBackupInvitee.value && messageBackups.length ? (
        <FormBackup
          messageBackups={messageBackups}
          currentBackup={currentMessageBackup}
          errorMessageBackup={errorMessageBackup.value}
        />
      ) : null}
    </div>
  )
}
export default TabCoversationDetail
